// Function component (presentational):

import React from 'react'

import { Formik } from 'formik'
import { Form, Input, SubmitButton } from 'formik-antd'

import { normalize } from '../../utils/misc'

import gtinFormSchema from '../../utils/yupSchema/gtinFormSchema'

import FormItem from '../shared/styledComponents/form/FormItem'

// import renderLabel from '../shared/other/renderLabel'

import { ScanOutlined, SearchOutlined } from '@ant-design/icons'
import { AutoComplete } from 'antd'
import TextRoundButton from '../shared/styledComponents/button/TextRoundButton'

const GtinForm = ({
	initialValues,
	options,
	toggleReader,
	// loading,
	navToFoodItem,
	// viewFoodItem,
	t,
}) => {
	const handleSubmit = ({ text }) => {
		navToFoodItem(text)

		// try {
		// 	viewFoodItem(text)
		// } catch (e) {
		// 	throw e
		// }
	}

	const prefix = <TextRoundButton icon={<ScanOutlined />} onClick={toggleReader} />

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={gtinFormSchema(t)}
			onSubmit={handleSubmit}
		>
			{({ values: { search } }) => (
				<Form
					// id="search-form"
					layout="vertical"
					colon={false}
				>
					<FormItem
						name="text"
						// label={renderLabel({ label: t('scanner:form.gtin.label') })}
						hasFeedback={false}
						style={{ marginBottom: 0 }}
					>
						<AutoComplete
							options={options}
							filterOption={(input, option) =>
								normalize(option?.value ?? '').includes(normalize(input))
							}
							onSelect={(value) => handleSubmit({ text: value })}
							// size="large"
							style={{ height: '100%' }}
						>
							<Input
								name="text"
								placeholder={t('scans:attributes.gtin.placeholder')}
								size="large"
								allowClear
								prefix={prefix}
								addonAfter={
									<SubmitButton
										// htmlType="submit"
										shape="circle"
										icon={<SearchOutlined />}
										// loading={loading}
										ghost
										style={{ border: 'none' }}
									/>
								}
							/>
						</AutoComplete>
					</FormItem>
				</Form>
			)}
		</Formik>
	)
}

export default GtinForm
